import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useRemoveMember } from "@/hooks/useRemoveMember";

interface RemoveMemberDialogProps {
  memberId: string;
  email: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RemoveMemberDialog({
  memberId,
  email,
  open,
  onOpenChange,
}: RemoveMemberDialogProps) {
  const removeMember = useRemoveMember();

  const handleRemove = async () => {
    try {
      await removeMember.mutateAsync(memberId);
      onOpenChange(false);
    } catch {
      // Error handled by mutation onError
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove Team Member</DialogTitle>
          <DialogDescription>
            Are you sure you want to remove{" "}
            <span className="font-medium text-foreground">{email}</span> from
            the team? They will no longer have access to the dashboard.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={removeMember.isPending}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleRemove}
            disabled={removeMember.isPending}
          >
            {removeMember.isPending && (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            )}
            {removeMember.isPending ? "Removing..." : "Remove Member"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
